<script setup lang="ts">import { computed as _computed } from 'vue';


import EntityItemComponent from './EntityItemComponent.vue'
import {PermissionEntityType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/PermissionEntityType'
import PermissionEntityItemThumbnailFactory from './factories/PermissionEntityItemThumbnailFactory.vue'
import {PermissionEntityTypeThumbnailStrategyMap} from './maps/PermissionEntityTypeThumbnailStrategyMap'

interface Props {
  entityType: PermissionEntityType
  entityId: string
  thumbnailPayload: unknown
  isActive?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  isActive: false,
})

const hasThumbnail = _computed(() => {
  return PermissionEntityTypeThumbnailStrategyMap.has(props.entityType)
})
</script>

<template>
  <EntityItemComponent :isActive="isActive">
    <template v-if="hasThumbnail" #thumbnail>
      <PermissionEntityItemThumbnailFactory :entityType="entityType" :payload="thumbnailPayload" :entityId="entityId"/>
    </template>
    <slot/>
  </EntityItemComponent>
</template>
